<template>
  <u-button>
    <span class="hidden sm:inline">
      <slot />
    </span>
  </u-button>
</template>
